var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 68.116,
    height: 69.432,
    viewBox: "0 0 68.116 69.432",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52731",
    "data-name": "Path 52731",
    d: "M0,25.679H68.116V-43.753H0Z",
    transform: "translate(0 43.753)",
    fill: "#3db6fb"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_50288",
    "data-name": "Group 50288",
    transform: "translate(0 43.753)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52727",
    "data-name": "Path 52727",
    d: "M7.7-15.638h4.08v4.069H7.7Z",
    transform: "translate(4.517 16.501)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_50287",
    "data-name": "Group 50287",
    transform: "translate(0 -43.753)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52728",
    "data-name": "Path 52728",
    d: "M12.214-11.342h4.08v-4.069h-4.08Zm0-4.069M38.836-34.868a20.022,20.022,0,0,0,5.37-1.36A15.19,15.19,0,0,0,48.315-39.3a5.969,5.969,0,0,1,4.653-2.009v-.411a2.034,2.034,0,0,0-2.034-2.034H2.034A2.034,2.034,0,0,0,0-41.719V23.644a2.034,2.034,0,0,0,2.034,2.034H33.86V8.607a2.035,2.035,0,0,1,2.034-2.034H52.968V4.227c-.062,0-.124,0-.184,0a6.017,6.017,0,0,1-2.941-.774l-.006,0-.006,0a31.329,31.329,0,0,1-9.777-8.639A33.493,33.493,0,0,1,34.5-17.236a37.593,37.593,0,0,1-.971-12.408,5.968,5.968,0,0,1,5.305-5.224M20.363,6.964A2.035,2.035,0,0,1,18.327,9H10.182A2.036,2.036,0,0,1,8.146,6.964V-1.172a2.036,2.036,0,0,1,2.036-2.034h8.146a2.035,2.035,0,0,1,2.036,2.034Zm0-16.272a2.036,2.036,0,0,1-2.036,2.034H10.182A2.037,2.037,0,0,1,8.146-9.308v-8.138a2.035,2.035,0,0,1,2.036-2.033h8.146a2.034,2.034,0,0,1,2.036,2.033Zm0-16.274a2.035,2.035,0,0,1-2.036,2.034H10.182a2.036,2.036,0,0,1-2.036-2.034v-8.136a2.036,2.036,0,0,1,2.036-2.034h8.146a2.035,2.035,0,0,1,2.036,2.034Zm-8.149-2.034h4.08v-4.069h-4.08Z",
    transform: "translate(0 43.753)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_50285",
    "data-name": "Group 50285",
    transform: "translate(37.928 54.394)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52729",
    "data-name": "Path 52729",
    d: "M0,5.561a2.046,2.046,0,0,0,1.439-.6L14.407-8a2.058,2.058,0,0,0,.632-1.473H0Z",
    transform: "translate(0 9.476)",
    fill: "#3db6fb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_50286",
    "data-name": "Group 50286",
    transform: "translate(37.451 6.511)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52730",
    "data-name": "Path 52730",
    d: "M11.3,2.988a1.9,1.9,0,0,0-1.687-1.66A24.447,24.447,0,0,1,2.9-.409,19.259,19.259,0,0,1-2.488-4.443a1.9,1.9,0,0,0-2.853,0A19.162,19.162,0,0,1-10.729-.409a24.442,24.442,0,0,1-6.709,1.738,1.9,1.9,0,0,0-1.688,1.66,33.776,33.776,0,0,0,.882,10.961A27.851,27.851,0,0,0-4.855,32.063a1.9,1.9,0,0,0,1.88,0,27.843,27.843,0,0,0,13.39-18.114A33.748,33.748,0,0,0,11.3,2.988M4.9,10.513l-7.639,8.852a2.041,2.041,0,0,1-2.982.109l-5.005-5a2.036,2.036,0,0,1,0-2.877,2.04,2.04,0,0,1,2.88,0L-4.4,15.047l6.21-7.19A2.035,2.035,0,0,1,4.9,10.513",
    transform: "translate(19.247 5.091)",
    fill: "#3db6fb"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.481e0ec022e0bbbee3d7d448c715b232.svg";
export { ForwardRef as ReactComponent };